// client/src/components/Admin/PlanesEducaCmp/_shared/PlanCard.js
//
// M07 - Card visual del plan. Reemplaza al PlanesItem legacy de Semantic UI.
// Layout: cover con miniatura + tag de cuenta, body con titulo + precio +
// descripcion truncada + 3 KPIs + meta + lista de features + footer con acciones.

import React from "react";
import { Tooltip, Button } from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  PictureOutlined,
} from "@ant-design/icons";
import { PlanAccountTag } from "./PlanAccountTag";
import { PlanFeatureList } from "./PlanFeatureList";
import styles from "./PlanCard.module.scss";

function formatPrice(price) {
  if (price === null || price === undefined) return "-";
  return new Intl.NumberFormat("es-ES").format(Number(price));
}

export function PlanCard({ plan, onEdit, onDelete }) {
  const visores = plan?.vrHeadsetNumber ?? 0;
  const alumnos = plan?.studentsNumber ?? 0;
  const meses = plan?.accessTime ?? 0;

  const metaParts = [
    plan?.vrHeadsetModel,
    plan?.bagModel ? `Maleta ${plan.bagModel}` : null,
    plan?.teacherNumber !== undefined
      ? `Para ${plan.teacherNumber} profesor${plan.teacherNumber === 1 ? "" : "es"}`
      : null,
  ].filter(Boolean);

  return (
    <div className={styles.planCard}>
      <div className={styles.cover}>
        {plan?.miniature ? (
          <img src={plan.miniature} alt={plan?.title || "Plan"} />
        ) : (
          <PictureOutlined className={styles.placeholder} />
        )}
        <div className={styles.topRight}>
          <PlanAccountTag account={plan?.account} />
        </div>
      </div>

      <div className={styles.body}>
        <div className={styles.titleRow}>
          <h3 className={styles.title} title={plan?.title}>
            {plan?.title || "(sin titulo)"}
          </h3>
          <div>
            <span className={styles.price}>{formatPrice(plan?.price)}</span>
            <span className={styles.priceUnit}> EUR</span>
          </div>
        </div>

        {plan?.description ? (
          <Tooltip title={plan.description} placement="top">
            <p className={styles.description}>{plan.description}</p>
          </Tooltip>
        ) : (
          <p className={styles.description}>Sin descripcion.</p>
        )}

        <div className={styles.kpiRow}>
          <div className={styles.kpi}>
            <span className={styles.num}>{visores}</span>
            <span className={styles.lbl}>Visores</span>
          </div>
          <div className={styles.kpi}>
            <span className={styles.num}>{alumnos}</span>
            <span className={styles.lbl}>Alumnos</span>
          </div>
          <div className={styles.kpi}>
            <span className={styles.num}>{meses}</span>
            <span className={styles.lbl}>Meses</span>
          </div>
        </div>

        {metaParts.length > 0 ? (
          <div className={styles.meta}>
            {metaParts.map((m, i) => (
              <React.Fragment key={m}>
                {i > 0 ? <span className={styles.dot}>·</span> : null}
                <span>{m}</span>
              </React.Fragment>
            ))}
          </div>
        ) : null}

        <PlanFeatureList plan={plan} />
      </div>

      <div className={styles.footer}>
        <Button
          icon={<EditOutlined />}
          onClick={() => onEdit?.(plan)}
          aria-label={`Editar plan ${plan?.title || ""}`}
        >
          Editar
        </Button>
        <Button
          danger
          icon={<DeleteOutlined />}
          onClick={() => onDelete?.(plan)}
          aria-label={`Eliminar plan ${plan?.title || ""}`}
        >
          Eliminar
        </Button>
      </div>
    </div>
  );
}
